import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import {
  MUNILY_WIZARD_STEPPER_DEFAULTS,
  WizardStepperItem,
} from './wizard-stepper.types';

@Component({
  selector: 'common-wizard-stepper',
  templateUrl: './wizard-stepper.component.html',
  styleUrls: ['./wizard-stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WizardStepperComponent {
  @Input() steps: WizardStepperItem[] = [];
  @Input() activeStep = 1;
  @Input() allowNavigation = MUNILY_WIZARD_STEPPER_DEFAULTS.allowNavigation;
  /** Step ids that cannot be navigated to via the stepper (prerequisites not met). */
  @Input() disabledSteps: number[] = [];
  @Output() stepChange = new EventEmitter<number>();

  trackStep(_: number, step: WizardStepperItem): number {
    return step.id;
  }

  isActive(step: WizardStepperItem): boolean {
    return this.activeStep === step.id;
  }

  isDone(step: WizardStepperItem): boolean {
    return this.activeStep > step.id;
  }

  isStepDisabled(step: WizardStepperItem): boolean {
    return !this.allowNavigation || this.disabledSteps.includes(step.id);
  }

  onStepClick(step: WizardStepperItem): void {
    if (this.isStepDisabled(step)) {
      return;
    }
    this.stepChange.emit(step.id);
  }
}
